import React from 'react';
import { ClickboxMenu } from '../../../../components/clickbox-menu/clickbox-menu';

export const ReferenceData = ({ ...props }) => {
  const menuItems = [
    {
      item: 'List of Tradeable Securities',
      path: '/sigmaxmtf/TradingInstrumentsCSVMiFIDIIAEP',
      isDownload: true,
      newTab: true,
    },
    {
      item: 'Tick Size Table',
      path: `/sigmaxmtf/TickSizeTableDownloadAEP`,
      isDownload: true,
      newTab: true,
    },
    {
      item: 'View Latest Instrument Changes',
      path: `/sigmaxmtf/news/securities-updates`,
      isDownload: false,
      newTab: true,
    },
  ];

  return (
    <div id="reference-data" aria-labelledby="reference-data-navigation-button">
      <ClickboxMenu menuItems={menuItems} aria={'Reference Data Menu'} />
    </div>
  );
};
